/**
 * @license Highcharts JS v12.2.0 (2025-04-07)
 * @module highcharts/modules/broken-axis
 * @requires highcharts
 *
 * (c) 2009-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */
'use strict';
import Highcharts from '../../Core/Globals.js';
import BrokenAxis from '../../Core/Axis/BrokenAxis.js';
const G = Highcharts;
G.BrokenAxis = G.BrokenAxis || BrokenAxis;
G.BrokenAxis.compose(G.Axis, G.Series);
export default Highcharts;
